/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Hero_BadgeInputs */

const en_business_hero_badge = /** @type {(inputs: Business_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Teams & Enterprises`)
};

const es_business_hero_badge = /** @type {(inputs: Business_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para equipos y empresas`)
};

/**
* | output |
* | --- |
* | "For Teams & Enterprises" |
*
* @param {Business_Hero_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_hero_badge = /** @type {((inputs?: Business_Hero_BadgeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Hero_BadgeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_hero_badge(inputs)
	return en_business_hero_badge(inputs)
});